import { getOfflineAuthor } from '../1-common/utils/author';
import { EPNodeFieldsResolvers } from '../5-node/fields';
const EPAnswerHistoryItemFieldsResolver = {
    async author() {
        return getOfflineAuthor();
    },
    async review() {
        return null;
    }
};
export const epAnswerFieldsResolvers = {
    EPAnswer: EPNodeFieldsResolvers,
    EPAnswerHistoryItem: EPAnswerHistoryItemFieldsResolver,
};
